import { ShieldOff } from "lucide-react";

export function SafetyBoundaryNotice() {
  return (
    <div
      className="flex items-start gap-2 px-3 py-2 rounded-md text-[10px] leading-relaxed border"
      style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface-soft)", color: "var(--oim-text-muted)" }}
      data-testid="safety-boundary-notice"
    >
      <ShieldOff className="w-3.5 h-3.5 mt-0.5 shrink-0" />
      <span>
        Advisory and diagnostic only. This system performs no protective function, is not a layer of protection,
        and issues no commands to any control or safety system.
      </span>
    </div>
  );
}
